@if (deeplinkIsAvailable$ | async) {
<div class="mb-1">
  <div class="flex justify-between items-center">
    <div class="font-bold mb-1">
      {{ 'notification-form.deeplink' | translate }}
    </div>
    <rk-switch [isChecked]="showDeeplinkOptions" (switched)="toggleDeeplinkOption()"></rk-switch>
  </div>
  @if (showDeeplinkOptions) {
  <p class="opacity-70 mb-3">
    {{ 'notification-form.deeplink-desc' | translate }}
  </p>
  @if ((isDeeplinksLoading$ | async) && tabOptions.length === 0) {
  <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
  } @else {
  <rk-dropdown [options]="tabOptions" [fullWidth]="true" (selectionChange)="onTabSelected($event)"
    [placeholder]="'notification-form.deeplink-placeholder' | translate" [selectedOption]="selectedTab || null"
    [showAbove]="true">
  </rk-dropdown>
  }

  @if (isPodcastDeeplinkSelected()) {
  <div class="mt-4" [@fadeInOut]>
    <div class=" mb-3 opacity-70">
      {{ 'notification-form.podcast-selection' | translate }}
    </div>
    @if ((isDeeplinksLoading$ | async) && podcastOptions.length === 0) {
    <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
    } @else {
    <div class="flex items-center gap-3 w-full">
      <rk-dropdown [options]="podcastOptions" [fullWidth]="true" (selectionChange)="onPodcastSelected($event)"
        [placeholder]="'notification-form.podcast-placeholder' | translate"
        [selectedOption]="getSelectedPodcastOption() || null" [showAbove]="true" class="flex-1 min-w-0">
      </rk-dropdown>
      @if (selectedPodcast) {
      <rk-button variant="delete" size="small" [iconOnly]="true" [icon]="'trash-alt'" (buttonClick)="onResetPodcast()">
      </rk-button>
      }

    </div>
    }

    @if (selectedPodcast) {
    <div class="mt-4">
      <div class="mb-3 opacity-70">
        {{ 'notification-form.episode-selection' | translate }}
      </div>
      @if ((isDeeplinksLoading$ | async) && episodeOptions.length === 0) {
      <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
      } @else {
      <div class="flex items-center gap-3 w-full">
        <rk-dropdown [options]="episodeOptions" [fullWidth]="true" (selectionChange)="onEpisodeSelected($event)"
          [placeholder]="'notification-form.episode-placeholder' | translate"
          [selectedOption]="getSelectedEpisodeOption() || null" [showAbove]="true" class="flex-1 min-w-0">
        </rk-dropdown>
        @if (selectedEpisode) {
        <rk-button variant="delete" size="small" [iconOnly]="true" [icon]="'trash-alt'" (buttonClick)="onResetEpisode()"
          class="flex-shrink-0">
        </rk-button>
        }
      </div>
      }
    </div>
    }
  </div>
  }

  @if (isRadioDeeplinkSelected()) {
  <div class="mt-4" [@fadeInOut]>
    <div class="mb-3 opacity-70">
      {{ 'notification-form.radio-selection' | translate }}
    </div>
    @if ((isDeeplinksLoading$ | async) && radioOptions.length === 0) {
    <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
    } @else {
    <rk-dropdown [options]="radioOptions" [fullWidth]="true" (selectionChange)="onRadioSelected($event)"
      [placeholder]="'notification-form.radio-placeholder' | translate"
      [selectedOption]="getSelectedRadioOption() || null" [showAbove]="true">
    </rk-dropdown>
    }
  </div>
  }
  }
</div>
}

<ng-template #loadingSpinner>
  <div class="flex spinner-container justify-center items-center w-full h-[50px]">
    <mat-progress-spinner mode="indeterminate" [strokeWidth]="3" [diameter]="24"></mat-progress-spinner>
  </div>
</ng-template>